import Service from '@/helpers/service'

export default {

    index(page, params) {
        return Service().get('sap-import?page=' + page, {params});
    },
    detail_log(code) {
        return Service().get('sap-import/detail-log/' + code);
    },
    detail_import_data(code, params) {
        return Service().get(`emcr/cataloguing-material/${code}`,  {params});
    },
    detail_import_failed(code, params) {
        return Service().get(`cataloguing-material/failed/${code}`,  {params});
    },
    data_released(code, params) {
        return Service().get(`emcr/cataloguing-material-released/${code}`,  {params});
    },
    delete(code) {
        return Service().post('sap-import/delete/' + code);
    },
    import_table(params) {
        return Service().post('sap-import-process', params);
    },
    send_to_sap(params) {
        return Service().post('emcr/cataloguing-material/send-to-sap', params);
    },
    import_material_cataloguing(params) {
        return Service().post('import-cataloguing', params);
    },
    export_failed(importCode, token) {
        return Service().get(`cataloguing-harmonisasi/export-failed-data/${importCode}?token=${token}`, { responseType: 'blob' });
    },
    export_success(importCode, token) {
        return Service().get(`cataloguing-harmonisasi/export-success-data/${importCode}?token=${token}`, { responseType: 'blob' });
    },
    export_log(importCode, token) {
        return Service().get(`sap-import/export-log/${importCode}?token=${token}`, { responseType: 'blob' });
    },
}